import React from "react";
import { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { format } from 'date-fns';
import html2pdf from "html2pdf.js";

import commonLabels from "../../../common/labels/common_en.json";
import label from "../../labels/interviewProcess_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getInterAttendeeList,
  printInterviewAttendeeList,
} from "../../actions/interviewProcessActions";
import { getYearList, getMainsAdvertisements } from "../../../common/actions/commonActions";
import { SET_ALL_INTERVIEW_ATTENDEE_LIST } from "../../../common/constants/ActionTypes";






const GenerateInterviewAttendeeList = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [reloadItem, setReloadItem] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const session = JSON.parse(sessionStorage.getItem("session"));
  const date = new Date(); // Your date object here
  const formattedDate = format(date, 'MM/dd/yyyy');
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0)
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let { examList, advertisementList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, getMainsAdvertisement } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { interviewAttendeeList } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  const onSubmit = () => { };
  const onCancelButton = () => {
    setSelectedExam("");
    examList.length = 0;
    setReloadItem(!reloadItem);
  };
  const printAttendeeListPDF = () => {
    genPdf();
    // dispatch(printInterviewAttendeeList(selectedExam));
  };
  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + interviewAttendeeList.examName + '</h5><h5>' + commonLabels.ATTENDEE_REPORT + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const examName = interviewAttendeeList.examName;

    const options = {
      margin: [0.8, 0.2, 0.8, 0.2],
      filename: 'Attendee_List_.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = interviewAttendeeList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Attendee_List_${examName}.pdf`);

      });
  };
  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    interviewAttendeeList.length = 0;
    selectedValue && dispatch(getInterAttendeeList(selectedValue));
    setReloadItem(!reloadItem);
  };
  const onSelectYear = (ele) => {

    let selectedValue = ele;
    setSelectedYear(selectedValue)
    selectedValue && dispatch(getMainsAdvertisements(selectedValue));
    if (getMainsAdvertisement) {
      getMainsAdvertisement.length = 0
    }
    if (examList) {
      examList.length = 0;
    }
    dispatch({
      type: SET_ALL_INTERVIEW_ATTENDEE_LIST,
      payload: []
    })
    setSaveButtonFlag(true);

    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    examList.length = 0;
    interviewAttendeeList.length = 0;
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };
  return (
    <div>
      <h5> {label.GenerateInterviewAttendeeList} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    value={selectedYear}
                    // ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {getMainsAdvertisement &&
                      getMainsAdvertisement.length > 0 &&
                      getMainsAdvertisement
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted === false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index + 1} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      {interviewAttendeeList && interviewAttendeeList.advertisementNo && (
        <>
          {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <div className="row ">
            <div className="col-md-12">
              {" "}
              <button
                type="button"
                className="btn btn-primary mb-2 float-right"
                onClick={() => {
                  printAttendeeListPDF();
                }}
              >
                {commonLabels.BUTTON_PRINT}
              </button>
            </div>
          </div>}
          <div ref={pdfRef} id="resultAttendeeList">

            <div className="row ">

              <div className="col-md-12">
                {interviewAttendeeList &&
                  interviewAttendeeList.interviewAttendances &&
                  interviewAttendeeList.interviewAttendances.length == 0 && <strong className="text-center w-100 float-left mt-5">No Attendee Found.</strong>}

                {interviewAttendeeList &&
                  interviewAttendeeList.interviewAttendances &&
                  interviewAttendeeList.interviewAttendances.length > 0 &&
                  interviewAttendeeList.interviewAttendances.map((ele, ind) => {
                    return (
                      <div className="centerDataSec" key={ind}>
                        <strong className="centerName">CENTRE : {ele.centerName}</strong><br /><br />
                        <strong>ATTENDEE</strong><br />
                        <ul className="rollList table-font-12">
                          {ele && ele.rollNumbers && ele.rollNumbers.length > 0 && ele.rollNumbers.map((rollno, index) => {
                            return (<li key={index}>{rollno}</li>)
                          })}

                        </ul>
                        <span className="totalAttendee">Total : {ele && ele.rollNumbers && ele.rollNumbers.length}</span>
                      </div>
                    );
                  })}

              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default GenerateInterviewAttendeeList;
